import { Button, Card } from 'ui';
import { useJoinOrganizationMutation } from '../../queries';

type P = {
  organizationId: string;
};

const OrganizationDetailJoinButton = ({ organizationId }: P) => {
  const { isPending: isJoiningOrganization, mutate: joinOrganization } = useJoinOrganizationMutation(organizationId);

  return (
    <Card>
      <Button
        block
        loading={isJoiningOrganization}
        onClick={() => {
          joinOrganization({ id: organizationId });
        }}
        type="primary"
      >
        Join Organization
      </Button>
    </Card>
  );
};

export default OrganizationDetailJoinButton;
